var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidenav",
      staticStyle: { "margin-left": "-15px", "margin-top": "-20px" }
    },
    [
      _c(
        "h1",
        {
          staticStyle: {
            padding: "28px 8px 18px 20px",
            background: "white",
            margin: "0"
          }
        },
        [_vm._v("\n    Menu\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c(
            "router-link",
            {
              class: { highlight: this.current == "provider" },
              attrs: { to: { name: "provider" } }
            },
            [_vm._v("General Info")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              class: { highlight: this.current == "general-info" },
              attrs: { to: { name: "general-info" } }
            },
            [_vm._v("Relevancy Info")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              class: { highlight: this.current == "key-statistics" },
              attrs: { to: { name: "key-statistics" } }
            },
            [_vm._v("Key Statistics")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              class: { highlight: this.current == "contact-page" },
              attrs: { to: { name: "contact-page" } }
            },
            [_vm._v("Contact")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              class: { highlight: this.current == "locale-page" },
              attrs: { to: { name: "locale-page" } }
            },
            [_vm._v("Locale")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              class: { highlight: this.current == "deal-page" },
              attrs: { to: { name: "deal-page" } }
            },
            [_vm._v("Deals")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              class: { highlight: this.current == "submit" },
              attrs: { tag: "a", to: { name: "submit" } }
            },
            [_vm._v("Overview")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ae3f5e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ae3f5e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/sideNav.vue
// module id = 75
// module chunks = 0